// Copyright (c) 2018 Deere & Company

import FormFieldsContainer from './form-fields-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.partReturns.requestDetails,
    security: state.user.security
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FormFieldsContainer);



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/index.js